import React, { useEffect } from "react";
import KWGoldReport from "../components/reports/GoldTestReport";
import { useLocation, useParams } from "react-router-dom";

function GoldTestReportPage() {
  const location = useLocation();

  const customerData = location.state?.requiredData;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      <KWGoldReport customerData={customerData} />
    </>
  );
}

export default GoldTestReportPage;
